module.exports = __webpack_public_path__ + "img/user-avater1.01d882f0.png";